// Define constants for cookie names
const COOKIE_NAMES = {
  WHATS_NEW_DISMISSED: "whatsNewBannerDismissed",
};

export const getCookie = (name: string): string | null => {
  const encodedName = encodeURIComponent(name);
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${encodedName}=`);
  if (parts.length === 2) {
    const cookieValue = parts.pop()?.split(";").shift() || null;
    return cookieValue ? decodeURIComponent(cookieValue) : null;
  }
  return null;
};

export const setCookie = (name: string, value: string, daysToExpire = 14): void => {
  const maxAge = daysToExpire * 24 * 60 * 60;
  document.cookie = `${encodeURIComponent(name)}=${encodeURIComponent(
    value
  )};Max-Age=${maxAge};path=/;SameSite=Strict;Secure`;
};

export { COOKIE_NAMES };
